import React, { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { Accordion, Form } from 'react-bootstrap';
import 'react-multi-carousel/lib/styles.css';

//component
import Banner from '../banner/banner'
import News from './news'
import Blog from './blogsList'



function Blogs() {
 

  return (
    <>
    <div className='container bg-white p-3 m-3'>
      <div className='title pb-2'>
        <h6>صفحه محصولات</h6>
      </div>
      <div className=''>
      <Accordion  >
          <div className=' [&>div]:px-2 [&>div]:py-3'>
            <div className='12'>
              <Accordion.Item eventKey="0">
                <Accordion.Header>تصاویر بنر اخبار و وبلاگ</Accordion.Header>
                <Accordion.Body>
                    <Banner slug='blogs1'/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="1">
                <Accordion.Header>اخبار</Accordion.Header>
                <Accordion.Body>
                    <News/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="2">
                <Accordion.Header>وبلاگ</Accordion.Header>
                <Accordion.Body>
                    <Blog/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
           
          </div>
        </Accordion>
      </div>
    </div>
    </>
  );
}

export default Blogs;
